module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Part-Title-1",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD6"
    }
  }, [_vm._v("THE INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD7"
    }
  }, [_vm._v("1. The Genesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD8"
    }
  }, [_vm._v("2. The Y")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Walk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Metamorphosis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Bunker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Move")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Juice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Digs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Vocational Opportunities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Ninth Annual Rose City Bench-Press Extravaganza")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Blitz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The San Gabriel Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Diet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Golden Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Aftermath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE IMAGE GALLERY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Fussell_Muscle_4P_MD23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1dfd7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fussell_Muscle_4P_MD3.vue
// module id = 69
// module chunks = 0